import { useContext } from 'react';
import Context from './Context';

const UserContext = () => useContext(Context);

export default UserContext;
